export default [
  {
    id: 'Ativa',
    colunas: ['SituacaoCadastral'],
    label: 'Ativa',
    valor: 'ATIVA',
  },
  {
    id: 'Baixado',
    colunas: ['SituacaoCadastral'],
    label: 'Baixado',
    valor: 'BAIXADO',
  },
  // {
  //   id: 'Vencido',
  //   colunas: ['Vencido'],
  //   label: 'Certificado vencido',
  //   valor: true,
  // },
  // {
  //   id: 'AVencer',
  //   colunas: ['AVencer'],
  //   label: 'A vencer (30 dias)',
  //   valor: true,
  // },
  {
    id: 'PossuiObservacao',
    colunas: ['PossuiObservacao'],
    label: 'Possui observação',
    valor: true,
  },
]
